/* src/config/routesConfig.js - Última MOdificación: 26-12-2025 */
/* ------------------------------------------------------------ */

/* Opciones Menú Admin */
import Clientes from '../components/pages/Clientes.jsx';
import Usuarios from '../components/pages/Usuarios.jsx';
import Entidades from '../components/pages/Entidades.jsx';
import Logsviewer from '../components/pages/Logsviewer.jsx';
import BullMQDashboard from '../components/pages/BullMQDashboard.jsx';


/* Opciones Menú Clientes */
import Misdatos from '../components/pages/Misdatos.jsx';
import Carpetascli from '../components/pages/Carpetascli.jsx';
import Rentascli from '../components/pages/Rentascli.jsx';
import Djcli from '../components/pages/Djcli.jsx';
import Libroventascli from '../components/pages/Libroventascli.jsx';
import Librocomprascli from '../components/pages/Librocomprascli.jsx';
import Resumenventascli from '../components/pages/Resumenventascli.jsx';
import Resumencomprascli from '../components/pages/Resumencomprascli.jsx';
import Estadisticaventascli from '../components/pages/Estadisticaventascli.jsx';
import Estadisticacomprascli from '../components/pages/Estadisticacomprascli.jsx';
import Informefinancierocliu from '../components/pages/Informefinancierocliu.jsx';
import Seguimiento from '../components/pages/Seguimiento.jsx';
import Dashboard from '../components/pages/Dashboard.jsx';

/* Opciones Menu Clientes -> Extractores */
import Extraerf22rentacli from '../components/pages/Extraerf22rentacli.jsx';
import Extraerlibroventascli from '../components/pages/Extraerlibroventascli.jsx';
import Extraerlibrocomprascli from '../components/pages/Extraerlibrocomprascli.jsx';
import Extraerdjcli from '../components/pages/Extraerdjcli.jsx';
import ExtraerLibroVentasAnualCli from '../components/pages/ExtraerLibroVentasAnualCli.jsx';
import ExtraerLibroComprasAnualCli from '../components/pages/ExtraerLibroComprasAnualCli.jsx';

/* Opciones Menu Clientes -> Subir Carpeta*/
import Subircarpetacli from '../components/pages/Subircarpetacli.jsx';

/* Opciones Menu Enrolados */
import Enrolados from '../components/pages/Enrolados.jsx';
import Carpetasenr from '../components/pages/Carpetasenr.jsx';
import Rentasenr from '../components/pages/Rentasenr.jsx';
import Djenr from '../components/pages/Djenr.jsx';
import Libroventasenr from '../components/pages/Libroventasenr.jsx';
import Librocomprasenr from '../components/pages/Librocomprasenr.jsx';
import Resumenventasenr from '../components/pages/Resumenventasenr.jsx';
import Resumencomprasenr from '../components/pages/Resumencomprasenr.jsx';
import Estadisticaventasenr from '../components/pages/Estadisticaventasenr.jsx';
import Estadisticacomprasenr from '../components/pages/Estadisticacomprasenr.jsx';
import Deudascmfenr from '../components/pages/Deudascmfenr.jsx';
import Informefinancieroenru from '../components/pages/Informefinancieroenru.jsx';

/* Opciones Menu Enrolados -> Extractores */
import Extraerf22rentaenr from '../components/pages/Extraerf22rentaenr.jsx';
import Extraerlibroventasenr from '../components/pages/Extraerlibroventasenr.jsx';
import Extraerlibrocomprasenr from '../components/pages/Extraerlibrocomprasenr.jsx';
import Extraercmfenr from '../components/pages/Extraercmfenr.jsx';
import Extraerdjenr from '../components/pages/Extraerdjenr.jsx';
import ExtraerLibroVentasAnualEnr from '../components/pages/ExtraerLibroVentasAnualEnr.jsx';
import ExtraerLibroComprasAnualEnr from '../components/pages/ExtraerLibroComprasAnualEnr.jsx';

/* Opciones Menu Enrolados -> Subir Carpeta */
import Subircarpetaenr from '../components/pages/Subircarpetaenr.jsx';

/* Opciones Menu Cesiones -> Deudor */
import Cesionesdeu from '../components/pages/Cesionesdeu.jsx';
import Crearpagos from '../components/pages/Crearpagos.jsx';
import Compagos from '../components/pages/Compagos.jsx';
import Conciliacion from '../components/pages/Conciliacion.jsx';
import Comconcil from '../components/pages/Comconcil.jsx';
import Estadisticacesionesdeu from '../components/pages/Estadisticacesionesdeu.jsx';
import Extraercesionesdeu from '../components/pages/Extraercesionesdeu.jsx';
import Misentidades from '../components/pages/Misentidades.jsx';

/* Opciones Menu Cesiones -> Cesionario */
import Cesionesces from '../components/pages/Cesionesces.jsx';
import Estadisticacesionesces from '../components/pages/Estadisticacesionesces.jsx';
import Extraercesionesces from '../components/pages/Extraercesionesces.jsx';

/* Opciones Menu Cesiones -> Cedente */
import Cesionesced from '../components/pages/Cesionesced.jsx';
import Estadisticacesionesced from '../components/pages/Estadisticacesionesced.jsx';
import Extraercesionesced from '../components/pages/Extraercesionesced.jsx';

/* Opciones Menu Recursos */
import Publicadas from '../components/pages/Publicadas.jsx';
import Extraerfapublicadas from '../components/pages/Extraerfapublicadas.jsx';
import Indicadores from '../components/pages/Indicadores.jsx';

/* Otras Opciones */
import Home from '../components/pages/Home.jsx';
import Perfil from '../components/pages/Perfil.jsx';
import Proveedores from '../components/pages/Proveedores.jsx';
import OverwatchMetrics from '../components/pages/OverwatchMetrics.jsx';

export const routesConfig = [
  /* Menu Admin */
  { path: 'clientes', element: Clientes, roles: ['ADMINISTRADOR'] },
  { path: 'usuarios', element: Usuarios, roles: ['ADMINISTRADOR'] },
  { path: 'entidades', element: Entidades, roles: ['ADMINISTRADOR'] },
  { path: 'logsviewer', element: Logsviewer, roles: ['ADMINISTRADOR'] },
  { path: 'bullmq', element: BullMQDashboard, roles: ['ADMINISTRADOR'] },
  { path: "metrics", element: OverwatchMetrics, roles: ["ADMINISTRADOR"] },

  /* Menu Clientes */
  { path: 'misdatos', element: Misdatos, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },
  { path: 'carpetascli', element: Carpetascli, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },
  { path: 'rentascli', element: Rentascli, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },
  { path: 'djcli', element: Djcli, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },
  { path: 'libroventascli', element: Libroventascli, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },
  { path: 'librocomprascli', element: Librocomprascli, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },
  { path: 'resumenventascli', element: Resumenventascli, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },
  { path: 'resumencomprascli', element: Resumencomprascli, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },
  { path: 'estadisticaventascli', element: Estadisticaventascli, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },
  { path: 'estadisticacomprascli', element: Estadisticacomprascli, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },
  { path: 'informefinancierocliu', element: Informefinancierocliu, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },
  { path: 'seguimiento', element: Seguimiento, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },
  { path: 'dashboard', element: Dashboard, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },

  /* Menu Clientes -> Extractores */
  { path: 'extraerf22rentacli', element: Extraerf22rentacli, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },
  { path: 'extraerlibroventascli', element: Extraerlibroventascli, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },
  { path: 'extraerlibrocomprascli', element: Extraerlibrocomprascli, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },
  { path: 'extraerdjcli', element: Extraerdjcli, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },
  { path: 'extraerlibroventasanualcli', element: ExtraerLibroVentasAnualCli, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },
  { path: 'extraerlibrocomprasanualcli', element: ExtraerLibroComprasAnualCli, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },

  /* Menu Clientes -> Subir Carpeta*/
  { path: 'subircarpetacli', element: Subircarpetacli, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },

  /* Menu Enrolados */
  { path: 'enrolados', element: Enrolados, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },
  { path: 'carpetasenr', element: Carpetasenr, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },
  { path: 'rentasenr', element: Rentasenr, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },
  { path: 'djenr', element: Djenr, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },
  { path: 'libroventasenr', element: Libroventasenr, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },
  { path: 'librocomprasenr', element: Librocomprasenr, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },
  { path: 'resumenventasenr', element: Resumenventasenr, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },
  { path: 'resumencomprasenr', element: Resumencomprasenr, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },
  { path: 'estadisticaventasenr', element: Estadisticaventasenr, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },
  { path: 'estadisticacomprasenr', element: Estadisticacomprasenr, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },
  { path: 'deudascmfenr', element: Deudascmfenr, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },
  { path: 'informefinancieroenru', element: Informefinancieroenru, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },

  /* Menu Enrolados -> Extractores */
  { path: 'extraerf22rentaenr', element: Extraerf22rentaenr, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },
  { path: 'extraerlibroventasenr', element: Extraerlibroventasenr, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },
  { path: 'extraerlibrocomprasenr', element: Extraerlibrocomprasenr, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },
  { path: 'extraercmfenr', element: Extraercmfenr, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },
  { path: 'extraerdjenr', element: Extraerdjenr, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },
  { path: 'extraerlibroventasanualenr', element: ExtraerLibroVentasAnualEnr, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },
  { path: 'extraerlibrocomprasanualenr', element: ExtraerLibroComprasAnualEnr, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },

  /* Menu Enrolados -> Subir Carpeta */
  { path: 'subircarpetaenr', element: Subircarpetaenr, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },

  /* Menu Cesiones -> Deudor */
  { path: 'cesionesdeu', element: Cesionesdeu, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },
  { path: 'crearpagos', element: Crearpagos, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },
  { path: 'compagos', element: Compagos, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },
  { path: 'conciliacion', element: Conciliacion, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },
  { path: 'comconcil', element: Comconcil, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },
  { path: 'estadisticacesionesdeu', element: Estadisticacesionesdeu, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },
  { path: 'extraercesionesdeu', element: Extraercesionesdeu, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },
  { path: 'misentidades', element: Misentidades, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },

  /* Menu Cesiones -> Cesionario */
  { path: 'cesionesces', element: Cesionesces, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },
  { path: 'estadisticacesionesces', element: Estadisticacesionesces, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },
  { path: 'extraercesionesces', element: Extraercesionesces, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },
  { path: 'misentidades', element: Misentidades, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },

  /* Menu Cesiones -> Cedente */
  { path: 'cesionesced', element: Cesionesced, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },
  { path: 'estadisticacesionesced', element: Estadisticacesionesced, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },
  { path: 'extraercesionesced', element: Extraercesionesced, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },
  { path: 'misentidades', element: Misentidades, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },

  /* Menu Recursos */
  { path: 'publicadas', element: Publicadas, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },
  { path: 'extraerfapublicadas', element: Extraerfapublicadas, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },
  { path: 'indicadores', element: Indicadores, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },

  /* Otras Opciones */
  { path: 'proveedores', element: Proveedores, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },
  { path: 'home', element: Home, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },
  { path: 'perfil', element: Perfil, roles: ['USUARIO', 'SUPERVISOR', 'ADMINISTRADOR'] },

];
